import React, { CSSProperties, ReactNode } from "react";

import { Grid } from "@material-ui/core";
import { useSelector } from "react-redux";

import { Row } from "components/Layout";
import { DialogTitle } from "components/MaterialDialog";
import OnlineStatus from "components/OnlineStatus";

import { getDashboardFetchingStatus, getOnlineStatus } from "selectors";

interface ModalTitleProps {
  onClose: () => void;
  children: ReactNode;
  style?: CSSProperties;
}

export const ModalTitle = ({ onClose, children, style }: ModalTitleProps) => {
  const onlineState = useSelector(getOnlineStatus);
  const isFetchingDashboardData = useSelector(getDashboardFetchingStatus);

  return (
    <DialogTitle onClose={onClose} style={style}>
      <Row fullWidth flex alignCenter paddingHorizontal={2} maxHeight="42px">
        <Grid item container xs={9} alignItems="center">
          {children}
        </Grid>
        <Grid item xs={3}>
          <OnlineStatus
            status={onlineState.status}
            pendingChangesCount={onlineState.changesOutboxSize}
            isFetching={isFetchingDashboardData}
            textColor="black"
          />
        </Grid>
      </Row>
    </DialogTitle>
  );
};
